import React from 'react';
import './AppTable.less';
import classNames from 'classnames';
import ResponsiveTable, {
    ResponsiveTableProps,
} from '@severalnines/bar-frontend-components/build/lib/DataDisplay/ResponsiveTable';
import { AppConfig } from '../../AppConfig';
import AppSpin from '../General/AppSpin';
import { Skeleton } from 'antd';
import AppEmpty from '../Feedback/AppEmpty';
import AppErrorState from '../Feedback/AppErrorState';

export default AppTable;

export type AppTableProps = Omit<
    ResponsiveTableProps,
    'dataSource' | 'onRow'
> & {
    renderEmpty?: React.ReactNode;
    loaded?: boolean;
    dataSource?: ResponsiveTableProps['dataSource'] | null;
    onRow?: ResponsiveTableProps['onRow'];
    error?: Error;
    unknownErrorMessage?: string;
    // onChange?: ResponsiveTableProps['onChange'];
};

function AppTable({
    className,
    dataSource,
    renderEmpty = <AppEmpty />,
    loading,
    pagination,
    loaded = true,
    locale,
    onRow = () => ({}),
    error,
    unknownErrorMessage,
    asListView,
    ...rest
}: AppTableProps) {
    const data = dataSource || undefined;
    const content = (
        <ResponsiveTable
            dataSource={data}
            className={classNames('AppTable', className)}
            pagination={{
                ...AppConfig.defaultPaginationConfig,
                ...pagination,
            }}
            locale={{ emptyText: renderEmpty, ...locale }}
            onRow={onRow}
            scroll={asListView ? undefined : { x: true }}
            asListView={asListView}
            {...rest}
            /*{ if total is 0 then we hide footer }*/
            {...(pagination?.total === 0 ? { footer: undefined } : {})}
        />
    );
    return error ? (
        <AppErrorState
            error={error}
            unknownErrorMessage={unknownErrorMessage}
        />
    ) : (
        <AppSpin spinning={!!loading}>
            {loaded && data !== undefined ? (
                content
            ) : data === undefined || loading || !loaded ? (
                <Skeleton />
            ) : (
                renderEmpty
            )}
        </AppSpin>
    );
}
